import { compressVideoOperation } from "./compressVideo";
import { convertAudioOperation } from "./convertAudio";
import { convertVideoOperation } from "./convertVideo";
import { extractAudioOperation } from "./extractAudio";
import { extractFrameOperation } from "./extractFrame";
import { mergeAudioOperation } from "./mergeAudio";
import { muteVideoOperation } from "./muteVideo";
import { normalizeAudioOperation } from "./normalizeAudio";
import { optimizeAudioOperation } from "./optimizeAudio";
import { rotateVideoOperation } from "./rotateVideo";
import { trimAudioOperation } from "./trimAudio";
import { trimVideoOperation } from "./trimVideo";
import type { MediaOperation } from "./types";

// Operations carry heterogeneous option shapes; the array erases the specific
// type parameter (`any` is intentional — the workspace re-infers per operation).
export type AnyOperation = MediaOperation<any>;

/**
 * Every operation. Imported only by `/studio` (the unified tool) — pulling this
 * in loads all tool code incl. mediabunny, which is fine for that one page.
 * Single-purpose pages import their own operation instead.
 */
export const ALL_OPERATIONS: AnyOperation[] = [
  optimizeAudioOperation,
  extractAudioOperation,
  convertAudioOperation,
  trimAudioOperation,
  normalizeAudioOperation,
  mergeAudioOperation,
  trimVideoOperation,
  convertVideoOperation,
  compressVideoOperation,
  muteVideoOperation,
  rotateVideoOperation,
  extractFrameOperation,
];
